//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer, ReadyState } from "react-relay";
// suggestions-feed imports
import { query } from "./SuggestionsFeedRenderer.gql";
import { IRendererProps, IRendererContainer, IRendererState } from "./SuggestionsFeed.d";
import { SuggestionsFeed } from "./SuggestionsFeed";
// other internals
import { handleReadyStateError } from "@util/relay.util";
import { logger } from "@util/logger.util";
import { IReduxState } from "@state/reducers/root.reducer";
import { suggestionsDebugFetchDate } from "@state/local-storage";

//////////////////
// COMPONENT
//////////////////
class SuggestionsFeedRendererWrapper extends React.PureComponent<IRendererProps, IRendererState> {
  private cachedViewer: ISchema.IViewer | null = null;
  private lastRendererFetch?: number;

  constructor(props: IRendererProps) {
    super(props);
    this.state = {
      boundaryError: false,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error("componentDidCatch in SuggestionsFeedRenderer", error, info);

    // Display fallback UI
    this.setState({ boundaryError: true });
  }

  public render() {
    const { fastCrawlFinished } = this.props;
    const debugFetchDateZonedMoment = suggestionsDebugFetchDate.get();
    const debugFetchDate = !!debugFetchDateZonedMoment
      ? debugFetchDateZonedMoment.valueOf()
      : undefined;

    return (
      <QueryRenderer
        environment={this.props.environment}
        query={query}
        variables={{ debugFetchDate, fastCrawlFinished }}
        cacheConfig={{}}
        render={(readyState: ReadyState) => {
          const freshViewer = readyState.props && readyState.props.viewer;
          const loadingForTheFirstTime = !this.cachedViewer && !freshViewer;

          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "SuggestionsFeedRenderer");

            return null;
          } else if (this.state.boundaryError) {
            return null;
          }

          // loading for the first time
          if (loadingForTheFirstTime) {
            return <span />;
          }

          // cache viewer so it doesn't flash on new loads
          if (freshViewer) {
            this.cachedViewer = freshViewer;
            this.lastRendererFetch = new Date().valueOf();
          }

          return (
            <SuggestionsFeed
              lastRendererFetch={this.lastRendererFetch}
              viewer={this.cachedViewer}
              updateCardCount={this.props.updateCardCount}
            />
          );
        }}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IRendererContainer) {
  return {
    fastCrawlFinished: state.onboarding.fastCrawlFinishedRefetchComplete,
  };
}

export const SuggestionsFeedRenderer = connect(mapStateToProps, {})(SuggestionsFeedRendererWrapper);
